import { j as t } from "./jsx-runtime-944c88e2.js";
import { Box as x, InputGroup as S, Input as R, InputRightElement as T, useToken as g, Text as y } from "@chakra-ui/react";
import * as F from "react";
import { useState as v, useRef as $, useEffect as k } from "react";
import { q as I, n as b } from "./useAccount-2421e215.js";
import "./myasurion-shared.mixpanel.es.js";
import { T as z } from "./TextEditIcon-56b71cbb.js";
import "./lodash-9598aa3c.js";
import "./domains-bf220bf9.js";
const P = ({
  id: d,
  value: o = "",
  showIcon: l = !0,
  placeholder: n,
  onChange: p,
  ...r
}) => {
  const [c, a] = v(), [e, i] = v(""), [m, u] = v(!1), f = () => a(!0), s = () => a(!1), h = $(null);
  return I("focus", f, h), I("blur", s, h), k(() => {
    !e && o && i(o);
  }, [o, e]), /* @__PURE__ */ t.jsxs(x, { position: "relative", children: [
    c && /* @__PURE__ */ t.jsx(
      x,
      {
        pos: "absolute",
        top: "2px",
        left: "10px",
        fontSize: "sm",
        fontWeight: 400,
        color: "gray.500",
        children: n
      }
    ),
    /* @__PURE__ */ t.jsxs(S, { children: [
      /* @__PURE__ */ t.jsx(
        R,
        {
          p: c ? "8px 12px" : "12px",
          minH: "56px",
          borderColor: "gray.300",
          placeholder: c ? "" : n,
          ref: h,
          onFocus: f,
          onBlur: s,
          value: e,
          onChange: (j) => {
            i(j.target.value), j.target.value !== o ? u(!0) : u(!1), p && p({ id: d, value: j.target.value });
          },
          ...r
        }
      ),
      m && l && /* @__PURE__ */ t.jsx(T, { p: "12px", children: /* @__PURE__ */ t.jsx(z, {}) })
    ] })
  ] });
}, { useState: E, useEffect: A } = F, W = ({
  placeholder: d,
  value: o = "",
  onChange: l = b,
  onBlur: n = b,
  ...p
}) => {
  const [r, c] = E(o), [a, e] = E(!1), i = g("components.Input.baseStyle.field.paddingX", "16px"), m = g(
    "components.Input.baseStyle.field._placeholder.color",
    "brand.neutral.deeper"
  ), u = (s) => {
    c(s.target.value), l == null || l(s);
  }, f = (s) => {
    e(r !== ""), n == null || n(s);
  };
  return A(() => {
    e(r !== "");
  }, [r]), /* @__PURE__ */ t.jsx(x, { children: /* @__PURE__ */ t.jsxs(x, { pos: "relative", children: [
    /* @__PURE__ */ t.jsx(S, { children: /* @__PURE__ */ t.jsx(
      R,
      {
        ...p,
        onFocus: () => e(!0),
        onBlur: f,
        value: r,
        onChange: u
      }
    ) }),
    /* @__PURE__ */ t.jsx(
      y,
      {
        top: a ? "25%" : "50%",
        left: i,
        transform: a ? "translate(-13%,-50%) scale(0.8)" : "translate(-20%,-50%) scale(1)",
        p: "0 12px",
        color: a ? "brand.black" : m,
        transformOrigin: "top left",
        transition: "all .2s ease-out",
        pointerEvents: "none",
        pos: "absolute",
        w: "fit-content",
        h: "fit-content",
        zIndex: "5",
        children: d
      }
    )
  ] }) });
};
export {
  W as Input,
  P as TextInput
};
